import { message } from "antd";

// Khớp với uploadFile.fileTypes của API (POST /files/upload)
const IMAGE_UPLOAD_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
];
const IMAGE_MAX_SIZE_MB = 2;

export const IMAGE_UPLOAD_ACCEPT = IMAGE_UPLOAD_TYPES.join(",");

// Trả về false (kèm thông báo lỗi) nếu ảnh không hợp lệ để upload lên API
export const validateImageFile = (file: File): boolean => {
  if (!IMAGE_UPLOAD_TYPES.includes(file.type)) {
    message.error("Chỉ hỗ trợ ảnh JPG, PNG, GIF, BMP hoặc WEBP!");
    return false;
  }
  if (file.size / 1024 / 1024 >= IMAGE_MAX_SIZE_MB) {
    message.error(`Hình ảnh phải nhỏ hơn ${IMAGE_MAX_SIZE_MB}MB!`);
    return false;
  }
  return true;
};
